/**
 * @generated SignedSource<<7a61eff8d3ec57c203a2139a113b7f3d>>
 * @relayHash 1e413b4d2635ec3dbab007d0b959441c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1e413b4d2635ec3dbab007d0b959441c

import { ConcreteRequest } from 'relay-runtime';
export type useChEmergencyPhoneNumbersQuery$variables = Record<PropertyKey, never>;
export type useChEmergencyPhoneNumbersQuery$data = {
  readonly ch_emergencyPhoneNumbers: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly phoneNumber: string;
    readonly postalCode: string;
  }>;
};
export type useChEmergencyPhoneNumbersQuery = {
  response: useChEmergencyPhoneNumbersQuery$data;
  variables: useChEmergencyPhoneNumbersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EmergencyPhoneNumber",
    "kind": "LinkedField",
    "name": "ch_emergencyPhoneNumbers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "postalCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useChEmergencyPhoneNumbersQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useChEmergencyPhoneNumbersQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "1e413b4d2635ec3dbab007d0b959441c",
    "metadata": {},
    "name": "useChEmergencyPhoneNumbersQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f9029d2a6f56a79f6524287902422e65";

export default node;
